export enum ItemSubnavigationItems {
    DESCRIPTION = 'description',
    SALES = 'sales',
    IMAGES = 'images',
    COMMISION = 'commision',
    ONLINE_SHOP = 'online-shop',
}
